module.exports = __webpack_public_path__ + "img/home-comment-bg-2022-small.f7e05672.png";